import './App.css';
import {Box, Button, IconButton, Typography} from "@mui/material";
import {ArrowForward, ArrowLeft, ArrowRight} from "@mui/icons-material";
import Forest1 from './images/forest1.jpg';
import Forest2 from './images/forest2.jpg';
import {useState} from "react";
import DefaultAppBar from "./AppBar";
import {Link} from "react-router-dom";
import DefaultFooter from "./DefaultFooter";

require('typeface-raleway');

const ImageGallery = () => {
    let images = [
        {image: Forest1, title: 'Forest 1', text: 'Forest 1'},
        {image: Forest2, title: 'Forest 2', text: 'Forest 2'},
    ];
    let [index, setIndex] = useState(0);
    return (
        <Box style={{position: "relative"}}>
            <img src={images[index].image} alt="A forest" draggable="false"
                 style={{
                     display: "block",
                     width: "100%",
                     height: "36em",
                     objectFit: "cover",
                     objectPosition: "center"
                 }}/>
            <Box style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Typography variant="h4"
                            style={{
                                flex: 1,
                                textAlign: "center",
                                color: "white",
                                fontWeight: "400",
                                fontSize: "4em",
                                margin: "0.5em",
                                fontFamily: "Raleway",
                                textShadow: "0 0 0.15em rgba(0,0,0,0.75)",
                                userSelect: "none"
                            }}>Keiblinger Sägetechnik</Typography>
            </Box>
            {/*<Box sx={{*/}
            {/*    position: "absolute",*/}
            {/*    top: '35%',*/}
            {/*    left: '60%',*/}
            {/*    right: '5%',*/}
            {/*    bottom: '35%',*/}
            {/*    backgroundColor: 'rgba(255, 255, 255, 1)',*/}
            {/*    borderRadius: '12px',*/}
            {/*    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.5)',*/}
            {/*}}>*/}
            {/*    <Box sx={{*/}
            {/*        position: "absolute",*/}
            {/*        top: '0',*/}
            {/*        left: '0',*/}
            {/*        width: '100%',*/}
            {/*        height: '100%',*/}
            {/*        padding: '26px',*/}
            {/*    }}>*/}
            {/*        <Typography variant="h4">*/}
            {/*            {images[index].title}*/}
            {/*        </Typography>*/}
            {/*        <Typography variant="body1">*/}
            {/*            {images[index].text}*/}
            {/*        </Typography>*/}
            {/*    </Box>*/}
            {/*</Box>*/}
            <Box sx={{
                position: "absolute",
                width: '100%',
                zIndex: 2,
                bottom: '0%',
                background: 'rgba(0, 0, 0, 0.45)',
                display: 'flex',
                justifyContent: 'center',
            }}>
                <IconButton sx={{color: "white"}}>
                    <ArrowLeft sx={{fontSize: "40px", color: "white"}} onClick={() => {
                        setIndex(index === 0 ? images.length - 1 : index - 1);
                    }}/>
                </IconButton>
                <IconButton sx={{color: "white"}}>
                    <ArrowRight sx={{fontSize: "40px", color: "white"}} onClick={() => {
                        setIndex(index === images.length - 1 ? 0 : index + 1);
                    }}/>
                </IconButton>
            </Box>
        </Box>
    );
}

const HomeContent = () => {
    return (
        <Box my='48px'>
            <Box>
                <Typography my='19px' variant='h3' textAlign='center' style={{
                    fontFamily: 'Raleway',
                    fontWeight: '500',
                }}>
                    Lohnschnitt vor Ort
                </Typography>
                <Typography variant='body1' textAlign='center' style={{
                    fontFamily: 'Raleway',
                    fontWeight: '400',
                    fontSize: '1.3em',
                }}
                >Sie haben Rundholz und wollen es zu Schnittholz weiterverarbeiten?<br/>Wir ersparen Ihnen den
                    aufwendigen
                    Transport zum Sägewerk
                    und verarbeiten stattdessen Ihr Rundholz vor Ort.<br/>
                    Egal ob Laub-, Obst- oder Nadelbaum, wir sind für alle Holzarten gerüstet.
                </Typography>
            </Box>
            <Box my='24px' display='flex' justifyContent='center'>
                <Button variant="outlined" endIcon={<ArrowForward/>} component={Link} to='/impressum'>Anfrage</Button>
            </Box>
        </Box>
    );
};

const Home = () => {
    return (
        <div className="Home">
            <DefaultAppBar fixed={true} transparent={true}/>
            <ImageGallery/>
            <HomeContent/>
            <DefaultFooter/>
        </div>
    );
}

export default Home;
